export default {
      id: "search-usage",
      viewBox: "0 0 20 18",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#search",
      toString: function () {
        return this.url;
      }
    }